import styles from '../styles/Archives.module.css';

const DescWhite = ({text}) => {
    return <div className={styles.descWhite}>{text}</div>
};

export default DescWhite;